import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Membership from './pages/Membership';
import LiveTechSupport from './pages/LiveTechSupport';
import VideoTraining from './pages/VideoTraining';
import SystemManuals from './pages/SystemManuals';
import Shop from './pages/Shop';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/live-tech-support" element={<LiveTechSupport />} />
        <Route path="/video-training" element={<VideoTraining />} />
        <Route path="/system-manuals" element={<SystemManuals />} />
        <Route path="/shop" element={<Shop />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;

